// Ticket 141: why BFY can't message a contact on a channel right now.
// `status` is GET /v2/comms/contacts/{id}/send-status —
// { sms: {allowed, reason}, email: {...}, call: {...}, inbound_dnd }.
const COPY = {
  suppressed: 'On the suppression list',
  consent_revoked: 'Consent revoked',
  dnd: 'DND in GoHighLevel',
  dnd_all: 'DND (all channels) in GoHighLevel',
  dnd_stop: 'Opted out (STOP) in GoHighLevel',
  dnd_unchecked: "Couldn't confirm DND with GoHighLevel",
};

// GHL DND proper; dnd_unchecked is an outage, not a DND setting.
export const isDnd = (reason) => ['dnd', 'dnd_all', 'dnd_stop'].includes(reason);

// Copy for a blocked channel, or null when the channel may send (or the
// status hasn't loaded — the server gates every send regardless).
export function blockText(status, channel) {
  const entry = status?.[channel];
  if (!entry || entry.allowed !== false) return null;
  if (entry.reason === 'no_address') return channel === 'email' ? 'No email on file' : 'No phone number on file';
  return COPY[entry.reason] || 'Messaging is blocked';
}
